import { CategorizationNode } from '@totem/components/ticketing/categorizationManagement/types';

type Option = { label: string; value: string };

const uniqueOptions = (names: string[]): Option[] =>
  Array.from(new Set(names.filter((name) => !!name)))
    .sort((left, right) => left.localeCompare(right))
    .map((name) => ({ label: name, value: name }));

const childrenOf = (nodes: CategorizationNode[], name?: string) =>
  name
    ? (nodes.find((node) => node.name === name)?.children ?? [])
    : nodes.flatMap((node) => node.children ?? []);

const names = (nodes: CategorizationNode[]) => nodes.map((node) => node.name);

// Match fields are independent (a blank one matches anything), so each list offers every value reachable from
// whatever is selected above it -- e.g. all Sub-Categories of a Type when no Category is chosen -- plus values
// already used by other entries, since tickets can carry values that aren't in the categorization tree.
export const typeOptions = (tree: CategorizationNode[], used: string[] = []) =>
  uniqueOptions([...names(tree), ...used]);

export const categoryOptions = (
  tree: CategorizationNode[],
  type?: string,
  used: string[] = [],
) => uniqueOptions([...names(childrenOf(tree, type)), ...used]);

export const subCategoryOptions = (
  tree: CategorizationNode[],
  type?: string,
  category?: string,
  used: string[] = [],
) =>
  uniqueOptions([
    ...names(childrenOf(childrenOf(tree, type), category)),
    ...used,
  ]);
